import * as React from 'react'
import { useParams } from 'react-router-dom'
import sanitise from 'sanitize-html'

const useSanitisedParams = <
  T extends { [K in keyof T]?: string } = Record<string, never>,
>(): T => {
  const params = useParams<T>()

  const sanitisedParams = React.useMemo(() => {
    const keys = Object.keys(params) as (keyof T)[]
    return keys.reduce<T>((newParams, key) => {
      const value = params[key]
      if (!value) {
        return newParams
      }
      newParams[key] = sanitise(value, {
        allowedTags: [],
        disallowedTagsMode: 'recursiveEscape',
      }) as T[keyof T]
      return newParams
    }, {} as T)
  }, [params])

  return sanitisedParams
}

export default useSanitisedParams
